import { render, staticRenderFns } from "./new-product-v2.modal.vue?vue&type=template&id=5e57ed80&scoped=true"
import script from "./new-product-v2.modal.vue?vue&type=script&lang=js"
export * from "./new-product-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./new-product-v2.modal.vue?vue&type=style&index=0&id=5e57ed80&prod&lang=scss&scoped=true"
import style1 from "./new-product-v2.modal.vue?vue&type=style&index=1&id=5e57ed80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e57ed80",
  null
  
)

export default component.exports